import React from 'react';
import {
  Database, Shield, Smartphone, ArrowRight, Cloud, Briefcase, Activity, Cpu, Wrench,
  Workflow,
  Gauge,
  Rocket,
} from 'lucide-react';
import Button from '../components/Button';

const Solutions = () => {
  const solutions = [
    {
      icon: Wrench,
      title: "Mechanical Engineering Design",
      desc: "Precision mechanical design solutions that optimize manufacturability, reduce cost and accelerate concept-to-production timelines.",
      color: "text-blue-500",
      bg: "bg-blue-500/10"
    },
    {
      icon: Workflow,
      title: "CAD Conversion & Automation",
      desc: "Transform legacy drawings into accurate, digital-ready formats — streamlining workflows and cutting manual effort.",
      color: "text-primary",
      bg: "bg-primary/10"
    },
    {
      icon: Gauge,
      title: "Engineering Analysis",
      desc: "Advanced FEA and CAE analysis that validates design performance, safety and reliability before production.",
      color: "text-accent-purple",
      bg: "bg-accent-purple/10"
    },
    {
      icon: Rocket,
      title: "Engineering Outsourcing",
      desc: "Access specialized engineering expertise on demand, reducing operational cost while accelerating project delivery.",
      color: "text-red-500",
      bg: "bg-red-500/10"
    },

    // {
    //   icon: Briefcase,
    //   title: "Fintech & Payments",
    //   desc: "Secure payment gateways, blockchain ledgers, and seamless core banking integrations.",
    //   color: "text-emerald-500",
    //   bg: "bg-emerald-500/10"
    // },
    // {
    //   icon: Cpu,
    //   title: "AI & Machine Learning",
    //   desc: "Custom LLMs, process automation, and predictive modeling bringing true AI value to your domain.",
    //   color: "text-amber-500",
    //   bg: "bg-amber-500/10"
    // }
  ];

  return (
    <div className="pt-24 min-h-screen">
      {/* Hero */}
      <section className="py-20 bg-navy">
        <div className="container-custom text-center">
          <div className="inline-block mb-4 px-4 py-1.5 rounded-full bg-white/10 border border-white/20">
            <span className="text-white font-semibold text-sm tracking-wide uppercase">ENGINEERING</span>
          </div>
          <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold text-white mb-6">
            Precision Engineering for a <span className="text-primary-light">Future-Ready World </span>
          </h1>
          <p className="text-lg md:text-xl text-white/70 max-w-3xl mx-auto leading-relaxed mb-10">
            From mechanical design to CAD conversion and advanced engineering analysis, our engineering services deliver enterprise-grade precision, quality and reliability — helping businesses move faster from concept to production.
          </p>
          <a href='/contact' style={{ display: 'flex', justifyContent: 'center' }}><Button variant="primary" className="px-8 py-4 text-lg border-none">
            Discuss Your Project
          </Button></a>
        </div>
      </section>

      {/* Solutions Grid */}
      <section className="py-24 bg-navy/5">
        <div className="container-custom">
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
            {solutions.map((solution, index) => (
              <div key={index} className="bg-white p-8 rounded-2xl shadow-lg border border-navy/5 group hover:-translate-y-2 transition-all duration-300">
                <div className={`w-14 h-14 rounded-xl ${solution.bg} flex items-center justify-center mb-6`}>
                  <solution.icon className={`w-7 h-7 ${solution.color}`} />
                </div>
                <h3 className="text-xl font-bold text-navy mb-4">{solution.title}</h3>
                <p className="text-navy/60 leading-relaxed mb-6">{solution.desc}</p>
                {/* <button className="flex items-center gap-2 text-primary font-semibold group-hover:gap-3 transition-all">
                  Learn more <ArrowRight size={18} />
                </button> */}
              </div>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
};

export default Solutions;
